import React from 'react';

const StatusDisplay = ({ children }) => {
    return (
        <div className="bg-gray-800 bg-opacity-50 p-4 rounded-lg flex flex-col items-center space-y-4">
            {children}
        </div>
    );
};

export default StatusDisplay;

